/**
 * @fileoverview useIntlLocale — React hook resolving the ACTIVE i18next
 * language to the Intl locale (ECO-RESIDUALS-CLEANUP-001 R3, 2026-07-30).
 *
 *     const locale = useIntlLocale();          // 'en-US' | 'es-US'
 *     const fmt = getFormatter(locale);        // locale-keyed formatter cache
 *
 * `useTranslation()` re-renders the caller on i18next's `languageChanged`
 * event, so formatters derived from this value recompute when the user flips
 * language. Provider-less renders (unit tests) resolve to `'en-US'` via
 * `intlLocaleFor`'s fallback.
 */

import { useTranslation } from 'react-i18next';
import { intlLocaleFor } from './intlLocaleFor.js';

/**
 * @returns {string} The Intl locale for the active UI language.
 */
export function useIntlLocale() {
  const { i18n } = useTranslation();
  return intlLocaleFor(i18n && i18n.language);
}

export default useIntlLocale;
